export default __webpack_public_path__ + "static/media/iconX.0c32efbe.svg";